import { render, staticRenderFns } from "./suifang.vue?vue&type=template&id=6241a872&scoped=true&"
import script from "./suifang.vue?vue&type=script&lang=js&"
export * from "./suifang.vue?vue&type=script&lang=js&"
import style0 from "./suifang.vue?vue&type=style&index=0&id=6241a872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241a872",
  null
  
)

export default component.exports